import { Model } from ".";

export default class TruckReport extends Model {
	get singularNoun() {
		return "truck report";
	}

	resource() {
		return "yard/reports/trucks";
	}
}
